/**
 * Session duration and warning constants for the frontend.
 *
 * These values MUST match the backend constants in backend/src/utils/constants.ts
 * (the TIME object). The backend is the authoritative source of truth — if session
 * durations change, update the backend constants first, then mirror here.
 *
 * TODO: Consider serving these values from the backend (e.g., via a /config
 * endpoint or embedding in the initial HTML) to eliminate manual duplication.
 */

// Session duration (30 minutes) — must match TIME.SESSION_DURATION_MS in backend
export const SESSION_DURATION_MS = 30 * 60 * 1000;
export const SESSION_DURATION_MINUTES = 30;

// Show warning popup this many ms before session expiry
// Must match TIME.SESSION_WARNING_BEFORE_EXPIRY_MS in backend
export const SESSION_WARNING_BEFORE_EXPIRY_MS = 5 * 60 * 1000;
